var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"col-6 d-flex",attrs:{"elevation":"4","loading":_vm.loadingChart}},[_c('canvas',{ref:"myChart",staticClass:"chartBar",attrs:{"width":"450","height":"200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }